import { FundingSource } from '../../../../../Nomination/components/NominationForm/FundingModule/types';
import { ViewSituation } from './ApplicationList';

type PanelRoundPermissionConfig = {
  enableEditColumns: boolean;
  enableAutoRefresh: boolean;
  enableSubmit: boolean;
  enableFilter: boolean;
  enableAddApplicant: boolean;
  enableSendLockedFilter: boolean;
  hideTopTen: boolean;
  hideSerialNo: boolean;
  hideNumberSummary: boolean;
  showIndex: boolean;
};

type PanelFundingConfig = {
  showReviewer: boolean;
  showRatingDetails: boolean;
  showDeptPriorityNo: boolean;
  showOccupiedQuota: boolean;
  showCSStudentshipYears: boolean;
  showDiscipline: boolean;
  showOfferedProgramme: boolean;
  showPartnerUniversity: boolean;
};

// TODO add more configuration like display certain column or not
export const panelApplicantListPermissionConfig: Record<
  ViewSituation,
  PanelRoundPermissionConfig
> = {
  [ViewSituation.GS]: {
    enableEditColumns: true,
    enableAutoRefresh: false,
    enableSubmit: true,
    enableFilter: true,
    enableAddApplicant: true,
    enableSendLockedFilter: true,
    hideTopTen: true,
    hideSerialNo: false,
    hideNumberSummary: false, // number of different panel result , and summary table
    showIndex: false,
  },
  [ViewSituation.MEMBER_NORMAL]: {
    enableEditColumns: false,
    enableAutoRefresh: true,
    enableSubmit: false,
    enableFilter: true,
    enableAddApplicant: false,
    enableSendLockedFilter: false,
    hideTopTen: true,
    hideSerialNo: false,
    hideNumberSummary: true,
    showIndex: false,
  },
  [ViewSituation.MEMBER_REVIEWEE_ONLY]: {
    enableEditColumns: false,
    enableAutoRefresh: false,
    enableSubmit: false,
    enableFilter: false,
    enableAddApplicant: false,
    enableSendLockedFilter: false,
    hideTopTen: true,
    hideSerialNo: true,
    hideNumberSummary: true,
    showIndex: true,
  },
};

// funding-based config
export const panelFundingConfig = (
  funding: FundingSource,
): PanelFundingConfig => {
  const isHKPFS = funding === FundingSource.HONGKONG_PHD_FELLOWSHIP_SCHEME;
  const isDual = funding === FundingSource.DUAL_PHD_DEGREE_PROGRAMME;
  return {
    showReviewer: isHKPFS,
    showRatingDetails: isHKPFS,
    showDeptPriorityNo: !isHKPFS,
    showOccupiedQuota: !isHKPFS,
    showPartnerUniversity: isDual, // related: partnerUniversity
    showCSStudentshipYears: !isHKPFS, // related: csStudentshipYears, csRemainStudentshipYears
    showDiscipline: isHKPFS,
    showOfferedProgramme: !isHKPFS,
  };
};
